import { createContext, useContext } from 'react';

export type PodcastEpisodeEmbedInteractionContextType = {
  onPlayAttempt?: () => void;
  getTooltipText?: (audioUrl?: string) => string | undefined;
  getIsPlaybackLocked?: (audioUrl?: string) => boolean;
};

export const PodcastEpisodeEmbedInteractionContext = createContext<PodcastEpisodeEmbedInteractionContextType | null>(
  null,
);

export const usePodcastEpisodeEmbedInteraction = () => useContext(PodcastEpisodeEmbedInteractionContext);
